<div *ngIf="view as v" class="call-bar" [ngClass]="'call-bar--' + v.tone" role="status">
  <span class="call-bar__icon" aria-hidden="true">
    <svg *ngIf="v.kind !== 'slot'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"></path></svg>
    <svg *ngIf="v.kind === 'slot'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 8v5M12 16h.01"></path></svg>
  </span>
  <span class="call-bar__text">
    <span class="call-bar__line">
      <b class="call-bar__lead">{{ v.lead }}</b>
      <span class="call-bar__who">{{ v.who }}</span>
      <span class="call-bar__meta">{{ v.meta }}</span>
    </span>
    <span *ngIf="v.sub" class="call-bar__sub">{{ v.sub }}</span>
  </span>
  <span class="call-bar__buttons">
    <button *ngIf="v.second" type="button" class="call-bar__second" (click)="hide(v)">{{ v.second.label }}</button>
    <button *ngIf="v.primary as primary" type="button" class="call-bar__primary" (click)="go(primary.action)">{{ primary.label }}</button>
  </span>
</div>
